const isEnabled = (key, featureFlags) => {
  // If feature flags don't exist within the object or the feature flag object is null
  // we are considering the flag disabled.
  if (!featureFlags || !Object.prototype.hasOwnProperty.call(featureFlags, key))
    return false

  return !!featureFlags[key]
}

/**
 * Generates a series of feature toggle functions that will instruct which features
 * are enabled or not
 * @param {Object} featureFlags Dictionary of feature flags
 */
export const createUserFeatureDecisions = (featureFlags) => {
  return {
    // #region Self Service
    growthHub: {
      /**
       * Enables Growth Hub tab and allows the page to be displayed
       *
       * @see {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/1360 User Story 1360 }
       * @returns true: displays Growth Hub tab and Growth Hub page. false: hides Growth Hub tab and prevents seeing Growth Hub page.
       */
      enableGrowthHub: isEnabled('r2W_GrowthHub_EnableGrowthHub', featureFlags),
    },
    shiftRecord: {
      /**
       * Enables Add New Shift option
       *
       * @returns true: displays option for AddNewShift. false: Hides Add New Shift Button
       */
      enableAddNewShift: isEnabled(
        'r2W_ShiftRecord_EnableAddNewShift',
        featureFlags
      ),
      /**
       * Enables the time entry UI elements (aka. Clock In/Clock Out)
       *
       * @see {@link https://dev.azure.com/anzukeducation/Staffroom%20NEXT/_workitems/edit/1345 User Story 1345}
       * @returns true: displays Clock In/Clock Out UI elements on the top bar. false: hides the clock in/clock out UI elements.
       */
      enableTimeEntries: isEnabled(
        'r2W_ShiftRecord_EnableTimeEntries',
        featureFlags
      ),
    },
    // #endregion
  }
}
